export default __webpack_public_path__ + "static/media/CT_CompA.67470276.png";